export function getSearchApiUrl(page: string | number = 1) {
    return `static-catalog-search?page=${page}`
}

export function createStaticPaths(
    pagesCount: number,
    slug?: string,
    data?: Record<string, string>
) {
    return Array.from({ length: pagesCount }, (_, i) => i + 1).map((page) => ({
        params: Object.assign(
            {
                page: page.toString(),
            },
            slug ? { slug } : {},
            data ? data : {}
        ),
    }))
}
